<template>
  <div id="csvTagConfig">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="contCsvConfig border-radius-bottom">
      <v-stepper v-model="step" vertical>
        <v-stepper-step :complete="step > 1" step="1" color="#27e96a">
          Descargar
          <small>Generar su archivo CSV</small>
        </v-stepper-step>

        <v-form ref="form">
          <v-stepper-content step="1">
            <div class="cont">
              <div class="contDateTime">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dates"
                      :rules="requiredRules"
                      label="Fecha"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      color="#27e96a"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dates"
                    range
                    scrollable
                    color="#27e96a"
                    header-color="black"
                  >
                  </v-date-picker>
                </v-menu>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  transition="scale-transition"
                  offset-y
                  :close-on-content-click="false"
                  :return-value.sync="time"
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="time"
                      v-model="time"
                      :rules="requiredRules"
                      placeholder="Seleccionar hora"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-on="on"
                      required
                    >
                    </v-text-field>
                  </template>
                  <v-time-picker
                    color="#27e96a"
                    header-color="black"
                    v-if="menu2"
                    v-model="time"
                    @click:minute="$refs.menu2.save(time)"
                    :value="time"
                  ></v-time-picker>
                </v-menu>
              </div>
              <div class="contBtn borderTop left">
                <div
                  class="button-secondary pl-4 pt-1 pb-1"
                  @click="getCSVFile()"
                >
                  <v-icon color="black">mdi-download</v-icon>
                  <span>Descargar CSV</span>
                </div>
              </div>
            </div>
            <div class="contBtn">
              <div @click="back()" class="btnCancel button-primary">
                <span>Cancelar</span>
              </div>
              <div @click="next()" class="btnSave button-tertiary">
                <span>Continuar</span>
              </div>
            </div>
          </v-stepper-content>
        </v-form>

        <v-stepper-step :complete="step > 2" step="2" color="#27e96a">
          Agregar etiquetas
          <small>Edite su archivo CSV</small>
        </v-stepper-step>

        <v-stepper-content step="2">
          <div class="step2">
            <div class="contH">
              <div class="iconCont">
                <v-icon>mdi-help</v-icon>
              </div>
              <span class="textH">Ayuda</span>
            </div>
            <span class="textC">
              Para identificar sus llamadas a través de etiquetas, abra el
              archivo descargado, agregue las columnas que considera necesarias
              y asigneles el nombre de la etiqueta, posteriormente en la fila
              del audio asigne el valor de la etiqueta correspondiente según sea
              el caso.
            </span>
            <span class="textC"
              >Una vez edite el archivo, guarde y continúe al siguiente
              paso.</span
            >
          </div>
          <div class="contBtn">
            <div @click="back()" class="btnCancel button-primary">
              <span>Atras</span>
            </div>
            <div @click="next()" class="btnSave button-tertiary">
              <span>Continuar</span>
            </div>
          </div>
        </v-stepper-content>

        <v-stepper-step :complete="step > 3" step="3" color="#27e96a">
          Cargar
          <small>Cargar el archivo CSV editado</small>
        </v-stepper-step>

        <v-form ref="form2">
          <v-stepper-content step="3">
            <div class="cont">
              <v-file-input
                v-model="file"
                :rules="requiredRules"
                color="#3ca0f5"
                label="Archivo CSV"
                placeholder="seleccionar archivo"
                prepend-icon="mdi-paperclip"
                outlined
              />
            </div>
            <div class="contBtn">
              <div @click="back()" class="btnCancel button-primary">
                <span>Atras</span>
              </div>
              <div @click="next()" class="btnSave button-tertiary">
                <span>Continuar</span>
              </div>
            </div>
          </v-stepper-content>
        </v-form>

        <v-stepper-step :complete="step > 4" step="3" color="#27e96a">
          Resultados
          <small>Procesamiento de etiquetado</small>
        </v-stepper-step>

        <v-stepper-content step="4">
          <div class="cont">
            <v-data-table
              :headers="headers"
              :items="data"
              :loading="loading"
              item-key="id"
              hide-default-footer
              disable-sort
              class="elevation-1"
            >
              <template v-slot:item.TotalCalls="{ item }">
                <div class="contCallsCount">
                  <div class="count">
                    <span
                      >{{ item.TotalCalls - item.CallsWithErrors }}/{{
                        item.TotalCalls
                      }}</span
                    >
                  </div>
                  <span
                    >Completadas
                    {{
                      ((item.TotalCalls - item.CallsWithErrors) /
                        item.TotalCalls) *
                      100
                    }}%</span
                  >
                </div>
              </template>
              <template v-slot:item.CallsWithErrors="{ item }">
                <div class="contError">
                  <v-icon>mdi-alert-outline</v-icon>
                  <div class="letterError" v-if="item.CallsWithErrors > 0">
                    {{ item.CallsWithErrors }}
                  </div>
                </div>
              </template>
              <template v-slot:item.date>
                {{ getDateToday() }}
              </template>
              <template v-slot:item.action>
                <div class="contDownloadCSV" @click="getCSVFile()">
                  <v-icon>mdi-download</v-icon>
                </div>
              </template>
            </v-data-table>
          </div>
          <div class="d-flex justify-end mt-7">
            <div @click="back()" class="btnCancel button-primary">
              <span>Atras</span>
            </div>
            <div @click="resetData()" class="btnSave button-tertiary">
              <span>Nuevo</span>
            </div>
          </div>
        </v-stepper-content>
      </v-stepper>
    </div>
    <v-snackbar v-model="showError" color="red" :timeout="2000" max-width="100">
      {{ textError }}
    </v-snackbar>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { DateTime } from "luxon";
import { httpByCurrentCustomer, downloadFromBlob } from "@/lib/client";
export default {
  data() {
    return {
      step: 1,
      file: "",
      dates: [],
      menu: null,
      menu2: null,
      time: "",
      data: [],
      headers: [
        {
          text: "Llamadas etiquetadas",
          value: "TotalCalls",
          sortable: "false",
        },
        { text: "Errores", value: "CallsWithErrors", sortable: "false" },
        { text: "Fecha", value: "date", sortable: "false" },
        { text: "", value: "action", sortable: "false" },
      ],
      requiredRules: [(v) => !!v || "Campo requerido"],
      loading: false,
      showError: false,
      textError: "",
    };
  },
  computed: {
    ...mapState("tagCSV", ["CSVTagResponseUpdate"]),
  },
  methods: {
    back() {
      if (this.step > 1) {
        if (this.step == 4) {
          this.data = [];
        }
        this.step = this.step - 1;
      }
    },
    next() {
      if (this.step == 1) {
        if (this.$refs.form.validate()) {
          this.getCSVFile();
        }
      } else if (this.step == 2) {
        this.step++;
      } else if (this.step == 3) {
        if (this.$refs.form2.validate()) {
          this.uploadCSVFile();
        }
      }
    },
    resetData() {
      this.step = 1;
      this.dates = [];
      this.file = "";
      this.time = "";
      this.data = [];
    },
    // GET CSV File
    async getCSVFile() {
      this.loading = true;
      const date = {
        startDate: new Date(this.dates[0]).toISOString(),
        endDate: new Date(
          this.dates[1] + " " + this.time + ":00"
        ).toISOString(),
      };
      try {
        await httpByCurrentCustomer()
          .get(`calls/csv?startDate=${date.startDate}&endDate=${date.endDate}`)
          .blob()
          .then((res) => {
            downloadFromBlob(res, `CSV_${date.startDate}_${date.endDate}.csv`);
          });
        if (this.step == 1) {
          this.step++;
        }
      } catch (error) {
        this.textError = error;
        this.showError = true;
      }
      this.loading = false;
    },
    async uploadCSVFile() {
      this.loading = true;
      const formData = new FormData();
      formData.append("csv_file", this.file);
      try {
        await this.$store.dispatch("tagCSV/upploadCSV", formData);
        this.data.push(this.CSVTagResponseUpdate);
        this.step++;
      } catch (error) {
        this.textError = error;
        this.showError = true;
      }
      this.loading = false;
    },
    getDateToday() {
      return DateTime.local().toFormat("yyyy-MM-dd");
    },
  },
};
</script>
<style lang="scss">
@import "../../styles/global.scss";

.v-application .primary--text {
  color: $primary-color !important;
  caret-color: $primary-color !important;
}
#csvTagConfig {
  width: auto;
  animation: fade 1s ease-in-out;
  .contCsvConfig {
    width: 100%;
    background: #ffffff;
    .contBtn {
      display: flex;
      padding: 15px 0 0 0;
      &.borderTop {
        border-top: 1px solid #e3e4e6;
        margin-top: 25px;
      }
      &.left {
        justify-content: flex-end;
      }
    }
    .btnCancel {
      border-radius: 10px;
      padding: 4px 5px;
      width: 100%;
      max-width: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      span {
        cursor: pointer;
        user-select: none;
      }
    }
    .btnSave {
      border-radius: 10px;
      padding: 4px 5px;
      width: 80%;
      max-width: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 15px;
      cursor: pointer;
      .v-icon {
        color: #ffffff;
        font-size: 20px;
        margin-right: 10px;
      }
      span {
        cursor: pointer;
        user-select: none;
      }
    }
    .cont {
      padding: 15px;
      display: flex;
      flex-direction: column;
      margin: 5px;
      border-radius: 7px;
      box-shadow: 5px 8px 12px -7px #777;
    }
    .contDateTime {
      display: flex;
      gap: 30px;
      justify-content: center;
      align-items: center;
    }
    .contCallsCount {
      display: flex;
      align-items: center;
      border: 1px solid $primary-color;
      width: fit-content;
      padding: 4px 6px;
      border-radius: 20px;
      background: #ededed;
      .count {
        background: $primary-color;
        padding: 2px 50px 2px 10px;
        border-radius: 20px;
        margin-right: 20px;
        span {
          color: #ffffff;
          font-weight: 300;
          cursor: default;
        }
      }
      span {
        font-size: 14px;
        font-weight: 500;
      }
    }
    .contError {
      position: relative;
      display: flex;
      align-items: center;
      width: fit-content;
      .v-icon {
        color: red;
      }
      .letterError {
        position: absolute;
        top: -4px;
        right: -13px;
        background: #f54748;
        border-radius: 20px;
        padding: 0 10px;
        height: 11px;
        display: flex;
        align-items: center;
        color: #ffffff;
        font-size: 9px;
      }
    }
    .contDownloadCSV {
      width: fit-content;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      border: 1px solid #dddddd;
      box-shadow: 0px 8px 10px -10px #777;
      padding: 3px 10px;
      cursor: pointer;
      .v-icon {
        font-size: 22px;
        color: #000;
      }
    }
    .step2 {
      display: flex;
      flex-direction: column;
      padding: 15px;
      border: 1px solid $border-gray;
      border-radius: 5px;
      background: $gray;
      .textC {
        font-size: 15px;
        font-weight: 400;
      }
      .textH {
        color: $border-gray;
        font-size: 15px;
        font-weight: 500;
      }
      .contH {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .iconCont {
          border: 1px solid $background-secondary;
          border-radius: 100%;
          width: 20px;
          height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 15px;
          .v-icon {
            font-size: 13px;
            color: $background-secondary;
          }
        }
      }
    }
  }
}
</style>
